<script setup>
import { ambitiData } from '@/graphql/queries/ambiti.js'

definePageMeta({
  layout: 'default',
})

const { locale } = useI18n()

const variables = computed(() => ({
  locale: locale.value,
}))

const { data } = await useGraphql(ambitiData, variables)

if (!data.value.ambiti || !data.value.allListaAmbitis) {
  throw createError({ statusCode: 404 })
}

const page = computed(() => data?.value.ambiti)
const lista = computed(() => data?.value.allListaAmbitis || [])

const seo = computed(() => page?.value.seo || {})
useSeo(seo)
</script>

<template>
  <div class="ambiti-page p-top-1a">
    <p v-if="page.titolo" class="intro-page-title text-3 row-400-20 max">
      {{ page.titolo }}
    </p>
    <IntroPagine v-if="page.intro" :intro="page.intro" />
    <PagineAmbitiAmbitiList v-if="lista" :lista-ambiti="lista" />
    <div class="black-bg">
      <AddaBlock class="p-top-7" />
      <PagineAmbitiEndPageSection v-if="lista" :ambiti="lista" />
    </div>
  </div>
</template>
